import { render } from "./FormSwitch.vue?vue&type=template&id=7b52b7b6&scoped=true"
import script from "./FormSwitch.vue?vue&type=script&lang=js"
export * from "./FormSwitch.vue?vue&type=script&lang=js"

import "./FormSwitch.vue?vue&type=style&index=0&id=7b52b7b6&lang=scss&scoped=true"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b52b7b6"]])

export default __exports__